module.exports = __webpack_public_path__ + "static/img/logo.ed2891e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 14